<mat-toolbar
  [dir]="frame?.rtlEnabled ? 'rtl' : 'auto'"
  color="primary"
  [ngClass]="{
    'toolbar-style': true,
    'detail-toolbar-style': this.frame.routing.getCurrentConfig().designation !== AppService.Route_WorkList
  }"
  >
  @if (this.frame.routing.getCurrentConfig().designation === AppService.Route_WorkList) {
    <span class="toolbar-header"
      >{{ dataSource.filteredData ? dataSource.filteredData.length : 0 }} {{ res.get('Works') }}</span
      >
      @if (dataSource.visibleFilters.length > 0) {
        &nbsp;({{ res.get('List-Filtered')
        }}@if (dataContext.isInAggregatedMode) {
        ,&nbsp;{{ res.get('Works-Aggregated') }}
        })
      }
      <span class="toolbar-spacer"></span>
      <button #searchMenuTrigger="matMenuTrigger" mat-icon-button [matMenuTriggerFor]="searchMenu" class="toolBarButton">
        <mat-icon [svgIcon]="res.svgName('Search-Image')"></mat-icon>
      </button>
      <mat-menu #searchMenu="matMenu" class="searchMenu">
        <div class="searchFormField">
          <abcAutoCompleteInput
            [placeHolder]="res.get('Search-PlaceHolder')"
            small="true"
            [panelBehaviour]="AutoCompletePanelBehaviour.OpenWhenTyping"
            [items]="allAutocompleteItems"
            (submit)="applyFilter($event)"
          ></abcAutoCompleteInput>
        </div>
      </mat-menu>
    } @else {
      <abcTileNavMenu>
        <tile customClass="works_NavigationHeader" (click)="this.worksService.navigateTo(AppService.Route_WorkList)">
          {{ res.get('Works') }}</tile
          >
          <tile customClass="works_NavigationHeader" (click)="this.worksService.navigateTo(AppService.Route_WorkDetail)">
            {{ res.get('Works-WorkSteps') }}</tile
            >
            @if (this.worksService.isResourceListVisible) {
              <tile
                customClass="works_NavigationHeader"
                (click)="this.worksService.navigateTo(AppService.Route_WorkDetail_ResourceList)"
                >
                {{ res.get('Resources') }}</tile
                >
              }
              @if (this.worksService.isResourceListVisible && this.worksService.getCurrentRessourceEventDetailName()) {
                <tile
                  customClass="works_NavigationHeader"
                  >
                  {{
                  res.get('Resources-RecordingOfRessourceEventOfType', this.worksService.getCurrentRessourceEventDetailName())
                  }}</tile
                  >
                }
                @if (this.frame.routing.getCurrentConfig().designation === AppService.Route_TaskDetail) {
                  <tile
                    customClass="works_NavigationHeader"
                    (click)="this.worksService.navigateTo(AppService.Route_TaskDetail)"
                    >{{ res.get('Works-Results') }}</tile
                    >
                  }
                </abcTileNavMenu>
                <!-- <div class="navigationHeader">{{ routingService.getCurrentConfig() === RouteConfig.WorkDetail ? workNavigationContext?.work?.toString() : workNavigationContext?.task?.toString() }}</div> -->
                <span class="toolbar-spacer"></span>
              }
              <button mat-icon-button class="toolBarButton" (click)="this.frame.lib.closeBottomSheet()">
                <mat-icon [svgIcon]="res.svgName('ExpandMore-Image')"></mat-icon>
              </button>
            </mat-toolbar>

            @if (!dataSource.isEmpty) {
              <div [@worksAnimation]="animationState">
                <router-outlet #routerOutlet="outlet" name="worksRouterOutlet"></router-outlet>
              </div>
            } @else {
              <!-- ideal: font-size: 6vw; -->
              <div class="noDataPlaceHolder">&lt;{{ res.get('Works-NoData') }}&gt;</div>
            }

